var exports = {
  "kL": "ForgotPasswordPage.module__container___ei1OUX",
  "DD": "ForgotPasswordPage.module__title___ei1OUX",
  "h_": "ForgotPasswordPage.module__description___ei1OUX",
  "Zd": "ForgotPasswordPage.module__form___ei1OUX",
  "qr": "ForgotPasswordPage.module__footer___ei1OUX",
  "nf": "ForgotPasswordPage.module__link___ei1OUX",
  "P9": "ForgotPasswordPage.module__primaryLink___ei1OUX",
  "kn": "ForgotPasswordPage.module__footerLabel___ei1OUX",
};

module.exports = exports;
